import { useEffect } from 'react'

import request from 'api'
import { setGeolocation, setIsAlertEnabled, useAppDispatch, useAppSelector } from 'store'
import i18n from 'utils/i18n'

interface GeolocationResponse {
  countryCode: string
}

export function useGeolocation(forceFetch = false) {
  const geolocation = useAppSelector((state) => state.session.geolocation)
  const isAlertEnabled = useAppSelector((state) => state.session.isAlertEnabled)
  const dispatch = useAppDispatch()

  const fetchGeolocation = async () => {
    const fetchedLocation = await request
      .get<GeolocationResponse>('/v1/countries')
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('Failed to fetch.')
        }
        return response.data.countryCode
      })
      .catch(() => {
        // Use country from i18n when failed to fetch via API.
        return i18n.language.split('-')[1]
      })
    dispatch(setGeolocation(fetchedLocation))
  }

  const disableAlert = async () => {
    dispatch(setIsAlertEnabled(false))
  }

  useEffect(() => {
    if (forceFetch || geolocation === '') {
      fetchGeolocation()
    }
  }, [])

  return {
    geolocation: geolocation === undefined ? '' : geolocation,
    isAlertEnabled: isAlertEnabled === undefined ? true : isAlertEnabled,
    isInitializing: geolocation === '',
    disableAlert,
    fetchGeolocation
  }
}
